import React, { useState } from "react";
import Loading from "../../Components/Loading";
import { renderPrice, timeSince } from "../../Utils/functions";
import { BsArrowRight, BsBookmark, BsBookmarkCheck } from "react-icons/bs";
import { useContactData, useSingle } from "./Hooks";

import { Form, Modal, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BiChevronLeft } from "react-icons/bi";
import SingleSlider from "../../Components/sliders/SingleSlider";
import { IoAlertOutline } from "react-icons/io5";
import Plan from "../Profile/Pages/Plan";
import { HiOutlineLogin } from "react-icons/hi";
import { useMainContext } from "../../Context";
import { FiAlertTriangle } from "react-icons/fi";
import { toast } from "react-toastify";
const Single = () => {
  const { data, loading, toggle, markLoading, navigate, handler, form, setForm, contactLoading } = useSingle();
  const { isLogin } = useMainContext();

  const [violationShow, setViolationShow] = useState(false);

  if (loading) {
    return (
      <div className="container">
        <div className="row">
          <Loading height={"200px"} />
        </div>
        <div className="row">
          <Loading count={3} height={"100px"} />
        </div>
      </div>
    );
  }

  let check = () => {
    let res = false;
    data?.ads?.options?.map(op => {
      if (op.id == 1) {
        res = true;
      }
    });
    return res;
  };

  return (
    <>
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">جزییات آگهی</p>
        </div>

        <button className="btn" onClick={toggle} disabled={markLoading}>
          {markLoading ? (
            <Spinner size="sm" />
          ) : data.mark == "false" ? (
            <>
              {
                <BsBookmark
                  color="rgba(255, 0, 31, 0.7490196078)"
                  size={"1.4rem"}
                />
              }
            </>
          ) : (
            <>
              {
                <BsBookmarkCheck
                  size={"1.4rem"}
                  color="rgba(255, 0, 31, 0.7490196078)"
                />
              }
            </>
          )}
        </button>
      </header>

      {!data.need_expence
        ? <div className="container">
          <div className="row">
            <div className="col">
              <div className="single">
                <div className="image">
                  <SingleSlider data={data?.ads} />
                </div>
                <div className="title-single">
                  <p className="AdName">{data?.ads?.title}</p>
                  {check() && (
                    <div className="context-single">
                      <div className="content-single">
                        <p className="txt">آگهی تاییدشده کارشناسان صنعتبان</p>
                      </div>
                      <p className="text">
                        آگهی موردنظر توسط صنعتبان تایید شده است
                      </p>
                    </div>
                  )}
                </div>
                <div>
                  <div className="box">
                    <div className="key-value-box">
                      <p className="key-box">نام آگهی دهنده:</p>
                      <p className="value-box">{data?.ads?.contacts_data?.fullname || data?.ads?.contacts_data?.co_name || data?.ads?.client?.fullname}</p>

                    </div>
                    <div className="key-value-box">
                      <p className="key-box">شهر:</p>

                      <p className="value-box">{data?.ads?.city?.title}</p>
                    </div>
                    <div className="key-value-box">
                      <p className="key-box">دسته بندی:</p>

                      <p className="value-box">{data?.ads?.category?.title}</p>
                    </div>
                    <div className="key-value-box">
                      <p className="key-box">قیمت:</p>
                      <p className="value-box">{renderPrice(data?.ads?.price)}</p>
                    </div>
                    <div className="info-single">
                      <p className="time-single">
                        {timeSince(data?.ads?.updated_at)}
                      </p>
                      <button className="info-btn-single" onClick={handler}>
                        <p>اطلاعات تماس</p>
                      </button>
                    </div>

                  </div>
                </div>
                <div className="description-single mb-4">
                  <p className="title-description-single">توضیحات:</p>
                  <div className="content-single">
                    <p className="text">{data?.ads?.description}</p>
                  </div>
                </div>

                <div className="Violation border-top mt-3 pt-2" style={{ fontSize: "14px" }}
                  onClick={e => {
                    setViolationShow(true)
                  }}>
                  <FiAlertTriangle className="ms-2" />
                  ثبت گزارش تخلف
                </div>
                {violationShow &&
                  <div className="violationBox">
                    <p className="mb-3 text-center border-bottonpb-2">
                      تخلف یا مشکل آگهی را انتخاب کنید
                    </p>

                    <Form dir="rtl">
                      <div className="mb-2">
                        <Form.Check name={"Violation"} id="Violation" type={"radio"} label={`کلاهبرداری، نقص قانون یا وقوع جرم`} />
                      </div>

                      <div className="mb-2">
                        <Form.Check name={"Violation"} id="Violation1" type={"radio"} label={`محتوای آگهی`} />
                      </div>

                      <div className="mb-2">
                        <Form.Check name={"Violation"} id="Violation2" type={"radio"} label={`مشکلات با صاحب آگهی`} />
                      </div>

                      <div className="mb-2">
                        <Form.Check name={"Violation"} id="Violation3" type={"radio"} label={`سایر`} />
                      </div>
                    </Form>

                    <div className="d-flex mt-4">
                      <button className="btn btn-outline-primary flex-fill mx-2"
                        onClick={e => setViolationShow(false)}>
                        انصراف
                      </button>
                      <button className="btn btn-primary flex-fill mx-2"
                        onClick={e => {
                          toast.success("گزارش شما با موفقیت ثبت شد");
                          setViolationShow(false)
                        }}>
                        تأیید
                      </button>

                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div >
        : <div className="row mx-0 position-relative">
          <div className="col-12 pt-2">
            <h6 className="text-danger alertForPlan sort-card d-flex justify-content-center py-3 border border-danger mb-4 mx-2">
              <IoAlertOutline size={"25px"} />
              کاربر گرامی جهت نمایش آگهی‌های این دسته بندی لطفا اشتراک تهیه نمائید
            </h6>
          </div>
          {isLogin()
            ?
            <div className="px-0 planBoxListPage">
              <Plan inList={true} />
            </div>
            :
            <Link className="btn btn-outline-primary mx-auto" to={"/login"} style={{ width: "200px" }}>
              <HiOutlineLogin className="ms-2" size={25} />
              <span>ورود / ثبت نام</span>
            </Link>
          }

        </div>

      }
      {/* <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={0}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            اطلاعات تماس
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {data.contacts_data ? (
            <>
              {
                data.contacts_data.fullname &&
                <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                  <p>نام و نام خانوادگی : </p>
                  <p>{data?.contacts_data?.fullname}</p>
                </div>
              }
              {
                data.contacts_data.co_name &&
                <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                  <p>نام شرکت : </p>
                  <p>{data?.contacts_data?.co_name}</p>
                </div>
              }
              {data.contacts_data.co_mobile &&
                <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                  <p>شماره تماس : </p>
                  <p>{data?.contacts_data?.co_mobile}</p>
                </div>
              }
              {data.contacts_data.mobile &&
                <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                  <p>شماره تماس : </p>
                  <p>{data?.contacts_data?.mobile}</p>
                </div>
              }
              {data.contacts_data.co_tell &&
                <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                  <p>تلفن ثابت  : </p>
                  <p>{data?.contacts_data?.co_tell}</p>
                </div>
              }
              {
                data.contacts_data.co_addres &&
                <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                  <p>آدرس شرکت : </p>
                  <p>{data?.contacts_data?.co_addres}</p>
                </div>
              }
              {
                data.contacts_data.co_url &&
                <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                  <p>آدرس سایت : </p>
                  <p>{data?.contacts_data?.co_url}</p>
                </div>
              }
              {data.contacts_data.email &&
                <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                  <p>ایمیل : </p>
                  <p>{data?.contacts_data?.email}</p>
                </div>
              }
            </>
          ) : (
            <>
              <p>برای مشاهده اطلاعات تماس باید پلن مربوط را خریداری کنید</p>
              <div className="d-flex justify-content-end">
                <Link className="btn btn-link btn-sm px-0" to={"/plans"}>
                  خرید اشتراک
                  <BiChevronLeft />
                </Link>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal> */}
      <Modal
        show={form.show}
        centered
        onHide={() => {
          setForm({ ...form, show: false });
        }}
      >
        <ContactDetails check={check} dataC={data?.ads?.client} />
      </Modal>
    </>
  );
};

export default Single;

const ContactDetails = ({ dataC, check }) => {
  const { data, loading } = useContactData();
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-baseline py-5">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="me-auto ms-auto">
          اطلاعات تماس
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data.contacts_data ? (
          <>
            {
              data.contacts_data.fullname &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>نام و نام خانوادگی : </p>
                <p>{data?.contacts_data?.fullname}</p>
              </div>
            }
            {
              data.contacts_data.co_name &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>نام شرکت : </p>
                <p>{data?.contacts_data?.co_name}</p>
              </div>
            }
            {data.contacts_data.co_mobile &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>شماره تماس : </p>
                <p>{data?.contacts_data?.co_mobile}</p>
              </div>
            }
            {data.contacts_data.mobile &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>شماره تماس : </p>
                <p>{data?.contacts_data?.mobile}</p>
              </div>
            }
            {data.contacts_data.co_tell &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>تلفن ثابت  : </p>
                <p>{data?.contacts_data?.co_tell}</p>
              </div>
            }
            {
              data.contacts_data.co_addres &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>آدرس شرکت : </p>
                <p>{data?.contacts_data?.co_addres}</p>
              </div>
            }
            {
              data.contacts_data.co_url &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>آدرس سایت : </p>
                <p>{data?.contacts_data?.co_url}</p>
              </div>
            }
            {data.contacts_data.email &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>ایمیل : </p>
                <p>{data?.contacts_data?.email}</p>
              </div>
            }

            {!check() && (
              <div className="warning-button">
                <p className="">
                  صنعتبان هیچ‌گونه منفعت و مسئولیتی در قبال معامله شما
                  ندارد .
                </p>
              </div>
            )}
          </>
        ) : (
          <>
            <p>برای مشاهده اطلاعات تماس باید پلن مربوط را خریداری کنید</p>
            <div className="d-flex justify-content-end">
              <Link className="btn btn-link btn-sm px-0" to={"/plans"}>
                خرید اشتراک
                <BiChevronLeft />
              </Link>
            </div>
          </>
        )}
      </Modal.Body>
    </>
  );
};
